import React from "react";
import "../styles/legal.css";
import { useTranslation, Trans } from "react-i18next"; // 1. Import

const PrivacyPolicy = () => {
  const { t } = useTranslation(); // 2. Initialize t

  // Helper to create list items, especially if they might contain simple HTML or need interpolation later
  const renderListItems = (baseKey) => {
    const items = t(baseKey, { returnObjects: true });
    if (!Array.isArray(items)) {
      // Fallback or log error if items are not an array
      console.warn(`Translation for ${baseKey} is not an array or is missing.`);
      return null;
    }
    return items.map((item, index) => <li key={index}>{item}</li>);
  };

  return (
    <div className="legal-container">
      <header className="legal-header">
        <h1>{t("privacyPolicy.header.title")}</h1>
        <p>{t("privacyPolicy.header.effectiveDate")}</p>
      </header>

      <section className="legal-section">
        <h2>{t("privacyPolicy.introduction.title")}</h2>
        <p>{t("privacyPolicy.introduction.content")}</p>
      </section>

      <section className="legal-section">
        <h2>{t("privacyPolicy.informationCollected.title")}</h2>
        <p>{t("privacyPolicy.informationCollected.intro")}</p>
        <ul>{renderListItems("privacyPolicy.informationCollected.list")}</ul>
      </section>

      <section className="legal-section">
        <h2>{t("privacyPolicy.howWeUse.title")}</h2>
        <p>{t("privacyPolicy.howWeUse.intro")}</p>
        <ul>{renderListItems("privacyPolicy.howWeUse.list")}</ul>
      </section>

      <section className="legal-section">
        <h2>{t("privacyPolicy.legalBasis.title")}</h2>
        <p>{t("privacyPolicy.legalBasis.intro")}</p>
        <ul>{renderListItems("privacyPolicy.legalBasis.list")}</ul>
      </section>

      <section className="legal-section">
        <h2>{t("privacyPolicy.dataRetention.title")}</h2>
        <p>{t("privacyPolicy.dataRetention.content")}</p>
      </section>

      <section className="legal-section">
        <h2>{t("privacyPolicy.yourRights.title")}</h2>
        <p>{t("privacyPolicy.yourRights.intro")}</p>
        <ul>{renderListItems("privacyPolicy.yourRights.list")}</ul>
      </section>

      <footer className="legal-footer">
        <p>
          <Trans i18nKey="privacyPolicy.footer.contact">
            For questions about this policy or to exercise your rights, contact
            us at: <a href="mailto:info@e-qera.com">info@e-qera.com</a>
          </Trans>
        </p>
        <p>
          {t("privacyPolicy.footer.copyright", {
            year: new Date().getFullYear(),
          })}
        </p>{" "}
        {/* Dynamic year */}
      </footer>
    </div>
  );
};

export default PrivacyPolicy;
